const OnEvent = {
  mounted() {
    const { event, command } = this.el.dataset

    if (!event || !command) {
      console.warn(
        "Missing data-event or data-command attributes for:",
        this.el,
      )
    }

    this.executeCommand = ({ target }) => {
      liveSocket.execJS(target, command)
    }

    this.el.addEventListener(event, this.executeCommand)
  },

  destroyed() {
    this.el.removeEventListener(event, this.executeCommand)
  },
}

export { OnEvent }
